
import React from 'react'
import insta from './svgs/insta.svg'
import { BaseIcon } from './_base'

export const InstaIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon ={insta} {...{fontSize,size,...sx}} />
    )
}
